import $ from 'jquery';
import "flexslider";
import "@fancyapps/fancybox";


$(document).ready(function() {
    if ( $('.zoomslider').length) {
        var $sliderItemTotal = $(".slider-item-total"),
		$sliderItemCurrent = $(".slider-item-current");

        $('.zoomslider').flexslider({
          animation: "slide",
          controlNav: false,
          touch: true,
          slideshow: false,
          start: function(item){
              slideCounter(item);
          },
          after: function(item){
              slideCounter(item);
          }
        });

        function slideCounter(item){
            $sliderItemCurrent.text(item.currentSlide + 1);
            $sliderItemTotal.text(item.count);
        }
      
        $().fancybox({
          selector : '.slides li:not(.clone) a',
          buttons: [
            "zoom",
            //"share",
            // "slideShow",
            //"fullScreen",
            //"download",
            "thumbs",
            "close"
          ],
          transitionEffect: "slide",
          hash   : false,
          share  : false,
          thumbs : {
            autoStart : false
          }
        });
      }

}); 


window.exposemap = function () {
    clearInterval(window.googleCheck);
    if(document.getElementById('exposemap')) {
        var map = new google.maps.Map(document.getElementById('exposemap'), {
            zoom: 17,
            scrollwheel:  false,
            // Es gibt keine lat und lng in diesem Fall -> Adresse wird verwendet
            center: new google.maps.LatLng(document.getElementById('exposemap').getAttribute('data-lng'), document.getElementById('exposemap').getAttribute('data-lat')),
            fullscreenControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: 
            [      
                {
                    "featureType": "administrative",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 65
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": "50"
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "lightness": "-13"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "all",
                    "stylers": [
                        {
                            "lightness": "20"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "lightness": "-21"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "all",
                    "stylers": [
                        {
                            "lightness": "30"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "hue": "#ffff00"
                        },
                        {
                            "lightness": -25
                        },
                        {
                            "saturation": -97
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "saturation": "-54"
                        },
                        {
                            "lightness": "35"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "lightness": -25
                        },
                        {
                            "saturation": -100
                        }
                    ]
                }
            ]
        });
    
        var strasse = document.getElementById('exposemap').getAttribute('data-street'); // strasse
        var address = document.getElementById('exposemap').getAttribute('data-address'); // stadt
        var miete = document.getElementById('exposemap').getAttribute('data-miete'); // miete
        var qm = document.getElementById('exposemap').getAttribute('data-qm'); // qm Fläche
        var zimmer = document.getElementById('exposemap').getAttribute('data-zimmer'); // zimmer
    
        var geocoder = new google.maps.Geocoder();
    
        geocoder.geocode({ 'address': address + ', ' + strasse + ', Germany' }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                // locations.push(results[0].geometry.location);
                //locations[i] = results[0].geometry.location;
                var marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location,
                    // url: document.getElementById('exposemapmarker').getAttribute('src'),
                    labelOrigin: new google.maps.Point(0, 0),
                //        icon: '/images/dogewo_pin.png'
                });
    
                var infoText = "<div class='g-map-bubble'><ul><li>" + strasse + '<br/>' + address + '</li><li>Kaltmiete: ' + miete + '</li><li>Wohnfläche: ' + qm + 
                            '</li><li>Zimmer: ' + zimmer + '</li></div>';
    
                var infowindow = new google.maps.InfoWindow({
                    content: infoText
                });
    
                google.maps.event.addListener(marker, 'click', function () {
                    infowindow.open(map, marker);
                });
                // addMarker(marker);
                map.setCenter(results[0].geometry.location);
                map.setZoom(17);
            } else {
                alert("Geocode was not successful for the following reason: " + status);
            }
        });
    }
};

window.deferGoogle = function(callback) {
    window.googleCheck = setInterval(function() {
        if (typeof window.google !== 'undefined') {
            clearInterval(window.googleCheck);
            if (typeof window[callback] === 'function') {
                // console.log('callback');
                window[callback]();
            }
        }
    }, 100);
};


/*if(document.querySelector("#exposemap") != null){
    setTimeout(function() {
        exposemap();
    }, 500);
    deferGoogle(exposemap);  
    
} */